<p-dialog [visible]="visible()" (visibleChange)="visible.set($event)" [modal]="true" [draggable]="false"
    [resizable]="false" [closable]="false" [dismissableMask]="true" [closeOnEscape]="true" [style]="{width: '500px'}">
    <ng-template #header>
        <h3 class="text-lg font-medium">{{ isEditMode() ? 'Edit User' : 'Add User' }}</h3>
    </ng-template>

    <div class="flex flex-col gap-4 py-2">
        <div class="flex flex-col gap-2">
            <label for="login" class="font-medium">Login (Username)</label>
            <input id="login" type="text" pInputText [ngModel]="login()" (ngModelChange)="login.set($event)"
                [disabled]="isEditMode()" placeholder="Enter login username" class="w-full"
                [class.ng-invalid]="loginError()" [class.ng-dirty]="formSubmitted()">
            <small class="text-red-500" *ngIf="loginError()">{{ loginError() }}</small>
        </div>

        <div class="flex flex-col gap-2">
            <label for="name" class="font-medium">Full Name</label>
            <input id="name" type="text" pInputText [ngModel]="name()" (ngModelChange)="name.set($event)"
                placeholder="Enter full name" class="w-full" [class.ng-invalid]="nameError()"
                [class.ng-dirty]="formSubmitted()">
            <small class="text-red-500" *ngIf="nameError()">{{ nameError() }}</small>
        </div>

        <div class="flex flex-col gap-2">
            <label for="email" class="font-medium">Email</label>
            <input id="email" type="email" pInputText [ngModel]="email()" (ngModelChange)="email.set($event)"
                placeholder="Enter email address" class="w-full">
        </div>

        <div class="flex flex-col gap-2">
            <label for="password" class="font-medium">Password {{ isEditMode() ? '(Optional)' : '' }}</label>
            <p-password id="password" [ngModel]="password()" (ngModelChange)="password.set($event)" [toggleMask]="true"
                [feedback]="!isEditMode()" class="w-full" styleClass="w-full" inputStyleClass="w-full"
                [placeholder]="isEditMode() ? 'Leave blank to keep current' : 'Enter password'"
                [styleClass]="passwordError() ? 'ng-invalid ng-dirty w-full' : 'w-full'">
            </p-password>
            <small class="text-red-500" *ngIf="passwordError()">{{ passwordError() }}</small>
        </div>

        <!-- Admin Only Fields -->
        <ng-container *ngIf="isAdminMode()">
            <div class="flex flex-col gap-2">
                <label for="role" class="font-medium">Role</label>
                <p-dropdown id="role" [options]="roles" [ngModel]="role()" (ngModelChange)="role.set($event)"
                    class="w-full" styleClass="w-full"></p-dropdown>
            </div>

            <div class="flex gap-4 mt-2">
                <div class="flex items-center gap-2">
                    <p-checkbox id="isActive" [binary]="true" [ngModel]="isActive()"
                        (ngModelChange)="isActive.set($event)"></p-checkbox>
                    <label for="isActive">Active</label>
                </div>
                <div class="flex items-center gap-2">
                    <p-checkbox id="isStaff" [binary]="true" [ngModel]="isStaff()"
                        (ngModelChange)="isStaff.set($event)"></p-checkbox>
                    <label for="isStaff">Staff</label>
                </div>
                <div class="flex items-center gap-2">
                    <p-checkbox id="isSuperuser" [binary]="true" [ngModel]="isSuperuser()"
                        (ngModelChange)="isSuperuser.set($event)"></p-checkbox>
                    <label for="isSuperuser">Superuser</label>
                </div>
            </div>
        </ng-container>
    </div>

    <ng-template pTemplate="footer">
        <p-button label="Cancel" icon="pi pi-times" (onClick)="onCancel()" [disabled]="loading()"
            styleClass="p-button-text">
        </p-button>
        <p-button [label]="isEditMode() ? 'Update' : 'Save'" icon="pi pi-check" (onClick)="onSave()"
            [disabled]="loading()" [loading]="loading()">
        </p-button>
    </ng-template>
</p-dialog>